module.exports = __webpack_public_path__ + "static/media/Cordoba.f6c00f95.svg";